import React from 'react';
import styled from 'styled-components';
import AVIFDetailCodec from './AVIFDetailCodec';
import AVIFDetailExamples from './AVIFDetailExamples';
import AVIFDetailResults from './AVIFDetailResults';
import AVIFEncodingSpeed from './AVIFEncodingSpeed';

const AVIFDetails = () => {
  return (
    <AVIFDetailsContainer>
      {/* codec */}
      <AVIFDetailCodec />

      {/* results */}
      <AVIFDetailResults />

      {/* examples */}
      <AVIFDetailExamples />

      {/* encoding speed */}
      <AVIFEncodingSpeed />
    </AVIFDetailsContainer>
  );
};

export default AVIFDetails;

const AVIFDetailsContainer = styled.div``;
